// import React, { useState, useEffect, useRef } from 'react';
// import { 
//   getAdminProfile, 
//   updateAdminProfile, 
//   changeAdminPassword, 
//   updateAdminSettings 
// } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ProfileManagement.css';
// import { useSelector } from 'react-redux';
// import '../../Styles/ProfileManagement.css';

// const SkeletonProfileImage = () => (
//   <div className="profile-image-container skeleton">
//     <div className="skeleton-profile-image"></div>
//   </div>
// );

// const SkeletonStatItem = () => (
//   <div className="stat-item skeleton">
//     <div className="skeleton-stat-number"></div>
//     <div className="skeleton-stat-label"></div>
//   </div>
// );

// const SkeletonDetailItem = () => (
//   <div className="detail-item skeleton">
//     <div className="skeleton-label"></div>
//     <div className="skeleton-value"></div>
//   </div>
// );

// const SkeletonSettingItem = () => (
//   <div className="setting-item skeleton">
//     <div className="skeleton-label"></div>
//     <div className="skeleton-value"></div>
//   </div>
// );

// const SkeletonPreferenceItem = () => (
//   <div className="preference-item skeleton">
//     <div className="skeleton-checkbox"></div>
//     <div className="skeleton-label"></div>
//   </div>
// );

// const SkeletonActivityItem = () => (
//   <div className="activity-item skeleton">
//     <div className="activity-info">
//       <div className="skeleton-activity-type"></div>
//       <div className="skeleton-activity-ip"></div>
//     </div>
//     <div className="skeleton-activity-time"></div>
//   </div>
// );

// const ProfileManagement = () => {
//   const [profileData, setProfileData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isEditing, setIsEditing] = useState(false);
//   const [isChangingPassword, setIsChangingPassword] = useState(false);
//   const [isEditingSettings, setIsEditingSettings] = useState(false);
//   const [editForm, setEditForm] = useState({});
//   const [passwordForm, setPasswordForm] = useState({
//     currentPassword: '',
//     newPassword: '',
//     confirmPassword: ''
//   });
//   const [settingsForm, setSettingsForm] = useState({});
//   const [profileImage, setProfileImage] = useState(null);
//   const fileInputRef = useRef(null);
//   const { token } = useSelector(state => state.user);

//   const fetchProfileData = async () => {
//     try {
//       setLoading(true);
//       const response = await getAdminProfile(token);
      
//       if (response.success) {
//         setProfileData(response.data);
//         setEditForm({
//           name: response.data.name,
//           phone: response.data.phone,
//           department: response.data.department
//         });
//         setSettingsForm(response.data.settings || {});
//       }
//     } catch (error) {
//       console.error('Error fetching profile:', error);
//       alert('Error fetching profile data: ' + (error.response?.data?.message || error.message));
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProfileData();
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handlePasswordChange = (e) => {
//     const { name, value } = e.target;
//     setPasswordForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSettingsChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setSettingsForm(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const handleDashboardSettingsChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setSettingsForm(prev => ({
//       ...prev,
//       dashboardPreferences: {
//         ...prev.dashboardPreferences,
//         [name]: type === 'checkbox' ? checked : value
//       }
//     }));
//   };

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (file) {

//       if (!file.type.startsWith('image/')) {
//         alert('Please select an image file');
//         return;
//       }

//       if (file.size > 5 * 1024 * 1024) {
//         alert('Image size should be less than 5MB');
//         return;
//       }

//       const formData = new FormData();
//       formData.append('profilePicture', file);
//       if (editForm.name) formData.append('name', editForm.name);
//       if (editForm.phone) formData.append('phone', editForm.phone);
//       if (editForm.department) formData.append('department', editForm.department);

//       try {
//         const response = await updateAdminProfile(formData, token);
        
//         if (response.success) {
//           setProfileData(prev => ({
//             ...prev,
//             ...response.data
//           }));
//           setProfileImage(URL.createObjectURL(file));
//           alert('Profile picture updated successfully!');
//         }
//       } catch (error) {
//         console.error('Error updating profile picture:', error);
//         alert('Error updating profile picture: ' + (error.response?.data?.message || error.message));
//       }
//     }
//   };

//   const handleEditImage = () => {
//     fileInputRef.current?.click();
//   };

//   const handleSaveProfile = async () => {
//     try {
//       const response = await updateAdminProfile(editForm, token);
      
//       if (response.success) {
//         setProfileData(prev => ({
//           ...prev,
//           ...response.data
//         }));
//         setIsEditing(false);
//         alert('Profile updated successfully!');
//       }
//     } catch (error) {
//       console.error('Error updating profile:', error);
//       alert('Error updating profile: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const handleSaveSettings = async () => {
//     try {
//       const response = await updateAdminSettings(settingsForm, token);
      
//       if (response.success) {
//         setProfileData(prev => ({
//           ...prev,
//           settings: response.data.settings
//         }));
//         setIsEditingSettings(false);
//         alert('Settings updated successfully!');
//       }
//     } catch (error) {
//       console.error('Error updating settings:', error);
//       alert('Error updating settings: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const handleChangePassword = async () => {
//     if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//       alert('New passwords do not match');
//       return;
//     }
    
//     try {
//       const response = await changeAdminPassword(passwordForm, token);
      
//       if (response.success) {
//         setPasswordForm({
//           currentPassword: '',
//           newPassword: '',
//           confirmPassword: ''
//         });
//         setIsChangingPassword(false);
//         alert('Password changed successfully!');
//       }
//     } catch (error) {
//       console.error('Error changing password:', error);
//       alert('Error changing password: ' + (error.response?.data?.message || error.message));
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditForm({
//       name: profileData.name,
//       phone: profileData.phone,
//       department: profileData.department
//     });
//     setIsEditing(false);
//   };

//   const handleCancelPasswordChange = () => {
//     setPasswordForm({
//       currentPassword: '',
//       newPassword: '',
//       confirmPassword: ''
//     });
//     setIsChangingPassword(false);
//   };

//   const handleCancelSettingsEdit = () => {
//     setSettingsForm(profileData.settings || {});
//     setIsEditingSettings(false);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'Never';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };

//   const formatTime = (dateString) => {
//     if (!dateString) return '';
//     return new Date(dateString).toLocaleTimeString('en-US', {
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   if (loading) {
//     return (
//       <div className="profile-management-page">
//         <div className="profile-page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="skeleton-header-subtitle"></div>
//         </div>

//         <div className="profile-content">
//           <div className="profile-card">
//             <div className="profile-header">
//               <div className="profile-image-section">
//                 <SkeletonProfileImage />
//                 <div className="profile-info">
//                   <div className="skeleton-name"></div>
//                   <div className="skeleton-role"></div>
//                   <div className="skeleton-email"></div>
//                   <div className="skeleton-department"></div>
//                 </div>
//               </div>
//               <div className="profile-stats">
//                 <SkeletonStatItem />
//                 <SkeletonStatItem />
//                 <SkeletonStatItem />
//               </div>
//             </div>
//             <div className="profile-actions">
//               <div className="skeleton-button"></div>
//             </div>
//           </div>

//           <div className="profile-details-grid">
//             <div className="detail-section">
//               <div className="skeleton-section-title"></div>
//               <div className="detail-grid">
//                 {[1, 2, 3, 4, 5, 6].map((i) => (
//                   <SkeletonDetailItem key={i} />
//                 ))}
//               </div>
//             </div>

//             <div className="detail-section">
//               <div className="section-header">
//                 <div className="skeleton-section-title"></div>
//                 <div className="skeleton-button small"></div>
//               </div>
//               <div className="settings-grid">
//                 {[1, 2, 3].map((i) => (
//                   <SkeletonSettingItem key={i} />
//                 ))}
//               </div>
//             </div>

//             <div className="detail-section">
//               <div className="skeleton-section-title"></div>
//               <div className="preferences-grid">
//                 {[1, 2, 3].map((i) => (
//                   <SkeletonPreferenceItem key={i} />
//                 ))}
//               </div>
//             </div>

//             <div className="detail-section">
//               <div className="skeleton-section-title"></div>
//               <div className="dashboard-settings-grid">
//                 {[1, 2].map((i) => (
//                   <SkeletonSettingItem key={i} />
//                 ))}
//                 <SkeletonPreferenceItem />
//               </div>
//             </div>

//             <div className="detail-section">
//               <div className="skeleton-section-title"></div>
//               <div className="security-actions">
//                 <div className="skeleton-button"></div>
//               </div>
//             </div>

//             <div className="detail-section">
//               <div className="skeleton-section-title"></div>
//               <div className="activity-list">
//                 {[1, 2, 3].map((i) => (
//                   <SkeletonActivityItem key={i} />
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!profileData) {
//     return (
//       <div className="profile-management-page">
//         <div className="error">Error loading profile data</div>
//       </div>
//     );
//   }

//   return (
//     <div className="profile-management-page">
//       <div className="profile-page-header">
//         <h1>Profile Management</h1>
//         <p>Manage your account settings and preferences</p>
//       </div>

//       <div className="profile-content">
//         <div className="profile-card">
//           <div className="profile-header">
//             <div className="profile-image-section">
//               <div className="profile-image-container">
//                 <img 
//                   src={profileImage || `http://192.168.29.29:5000${profileData.profilePicture}`}
//                   alt="Profile" 
//                   className="profile-image"
//                   onError={(e) => {
//                     e.target.onerror = null;
//                     e.target.src = 'https://via.placeholder.com/120x120?text=Profile';
//                   }}
//                 />
//                 <button 
//                   className="edit-image-btn"
//                   onClick={handleEditImage}
//                 >
//                   <span>✎</span>
//                 </button>
//                 <input
//                   type="file"
//                   ref={fileInputRef}
//                   onChange={handleImageUpload}
//                   accept="image/*"
//                   style={{ display: 'none' }}
//                 />
//               </div>
//               <div className="profile-info">
//                 <h2>{profileData.name}</h2>
//                 <p className="profile-role">{profileData.role}</p>
//                 <p className="profile-email">{profileData.email}</p>
//                 <p className="profile-department">{profileData.department}</p>
//               </div>
//             </div>
//             <div className="profile-stats">
//               <div className="stat-item">
//                 <span className="stat-number">{profileData.stats?.totalLogins || 0}</span>
//                 <span className="stat-label">Total Logins</span>
//               </div>
//               <div className="stat-item">
//                 <span className="stat-number">{profileData.stats?.loginStreak || 0}</span>
//                 <span className="stat-label">Login Streak</span>
//               </div>
//               <div className="stat-item">
//                 <span className="stat-number">
//                   {profileData.lastLogin ? formatDate(profileData.lastLogin) : 'Never'}
//                 </span>
//                 <span className="stat-label">Last Login</span>
//               </div>
//             </div>
//           </div>

//           <div className="profile-actions">
//             {!isEditing ? (
//               <button 
//                 className="edit-profile-btn"
//                 onClick={() => setIsEditing(true)}
//               >
//                 Edit Profile
//               </button>
//             ) : (
//               <div className="edit-actions">
//                 <button 
//                   className="save-btn"
//                   onClick={handleSaveProfile}
//                 >
//                   Save Changes
//                 </button>
//                 <button 
//                   className="cancel-btn"
//                   onClick={handleCancelEdit}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>


//         <div className="profile-details-grid">

//           <div className="detail-section">
//             <h3>Personal Information</h3>
//             <div className="detail-grid">
//               <div className="detail-item">
//                 <label>Full Name</label>
//                 {isEditing ? (
//                   <input
//                     type="text"
//                     name="name"
//                     value={editForm.name || ''}
//                     onChange={handleInputChange}
//                     className="edit-input"
//                   />
//                 ) : (
//                   <span>{profileData.name}</span>
//                 )}
//               </div>
              
//               <div className="detail-item">
//                 <label>Email Address</label>
//                 <span>{profileData.email}</span>
//               </div>
              
//               <div className="detail-item">
//                 <label>Phone Number</label>
//                 {isEditing ? (
//                   <input
//                     type="tel"
//                     name="phone"
//                     value={editForm.phone || ''}
//                     onChange={handleInputChange}
//                     className="edit-input"
//                     placeholder="Enter phone number"
//                   />
//                 ) : (
//                   <span>{profileData.phone || 'Not set'}</span>
//                 )}
//               </div>
              
//               <div className="detail-item">
//                 <label>Department</label>
//                 {isEditing ? (
//                   <input
//                     type="text"
//                     name="department"
//                     value={editForm.department || ''}
//                     onChange={handleInputChange}
//                     className="edit-input"
//                   />
//                 ) : (
//                   <span>{profileData.department}</span>
//                 )}
//               </div>
              
//               <div className="detail-item">
//                 <label>Join Date</label>
//                 <span>{formatDate(profileData.createdAt)}</span>
//               </div>
              
//               <div className="detail-item">
//                 <label>Last Updated</label>
//                 <span>{formatDate(profileData.updatedAt)}</span>
//               </div>
//             </div>
//           </div>


//           <div className="detail-section">
//             <div className="section-header">
//               <h3>Account Settings</h3>
//               {!isEditingSettings ? (
//                 <button 
//                   className="edit-settings-btn"
//                   onClick={() => setIsEditingSettings(true)}
//                 >
//                   Edit Settings
//                 </button>
//               ) : (
//                 <div className="edit-actions">
//                   <button 
//                     className="save-btn small"
//                     onClick={handleSaveSettings}
//                   >
//                     Save
//                   </button>
//                   <button 
//                     className="cancel-btn small"
//                     onClick={handleCancelSettingsEdit}
//                   >
//                     Cancel
//                   </button>
//                 </div>
//               )}
//             </div>
            
//             <div className="settings-grid">
//               <div className="setting-item">
//                 <label>Language</label>
//                 {isEditingSettings ? (
//                   <select
//                     name="language"
//                     value={settingsForm.language || 'en'}
//                     onChange={handleSettingsChange}
//                     className="edit-select"
//                   >
//                     <option value="en">English</option>
//                     <option value="hi">Hindi</option>
//                     <option value="es">Spanish</option>
//                     <option value="fr">French</option>
//                     <option value="de">German</option>
//                   </select>
//                 ) : (
//                   <span>
//                     {settingsForm.language === 'en' ? 'English' :
//                      settingsForm.language === 'hi' ? 'Hindi' :
//                      settingsForm.language === 'es' ? 'Spanish' :
//                      settingsForm.language === 'fr' ? 'French' :
//                      settingsForm.language === 'de' ? 'German' : 'English'}
//                   </span>
//                 )}
//               </div>

//               <div className="setting-item">
//                 <label>Timezone</label>
//                 {isEditingSettings ? (
//                   <select
//                     name="timezone"
//                     value={settingsForm.timezone || 'UTC'}
//                     onChange={handleSettingsChange}
//                     className="edit-select"
//                   >
//                     <option value="UTC">UTC</option>
//                     <option value="Asia/Kolkata">India (IST)</option>
//                     <option value="America/New_York">New York (EST)</option>
//                     <option value="Europe/London">London (GMT)</option>
//                     <option value="Asia/Tokyo">Tokyo (JST)</option>
//                   </select>
//                 ) : (
//                   <span>{settingsForm.timezone || 'UTC'}</span>
//                 )}
//               </div>

//               <div className="setting-item">
//                 <label>Theme</label>
//                 {isEditingSettings ? (
//                   <select
//                     name="theme"
//                     value={settingsForm.theme || 'light'}
//                     onChange={handleSettingsChange}
//                     className="edit-select"
//                   >
//                     <option value="light">Light</option>
//                     <option value="dark">Dark</option>
//                     <option value="system">System</option>
//                   </select>
//                 ) : (
//                   <span>
//                     {settingsForm.theme === 'light' ? 'Light' :
//                      settingsForm.theme === 'dark' ? 'Dark' :
//                      settingsForm.theme === 'system' ? 'System' : 'Light'}
//                   </span>
//                 )}
//               </div>
//             </div>
//           </div>


//           <div className="detail-section">
//             <h3>Notification Preferences</h3>
//             <div className="preferences-grid">
//               <div className="preference-item">
//                 <label className="checkbox-label">
//                   <input
//                     type="checkbox"
//                     name="notifications"
//                     checked={settingsForm.notifications !== false}
//                     onChange={handleSettingsChange}
//                     disabled={!isEditingSettings}
//                   />
//                   <span className="checkmark"></span>
//                   Push Notifications
//                 </label>
//               </div>
              
//               <div className="preference-item">
//                 <label className="checkbox-label">
//                   <input
//                     type="checkbox"
//                     name="emailNotifications"
//                     checked={settingsForm.emailNotifications !== false}
//                     onChange={handleSettingsChange}
//                     disabled={!isEditingSettings}
//                   />
//                   <span className="checkmark"></span>
//                   Email Notifications
//                 </label>
//               </div>
              
//               <div className="preference-item">
//                 <label className="checkbox-label">
//                   <input
//                     type="checkbox"
//                     name="smsNotifications"
//                     checked={settingsForm.smsNotifications || false}
//                     onChange={handleSettingsChange}
//                     disabled={!isEditingSettings}
//                   />
//                   <span className="checkmark"></span>
//                   SMS Notifications
//                 </label>
//               </div>
//             </div>
//           </div>


//           <div className="detail-section">
//             <h3>Dashboard Preferences</h3>
//             <div className="dashboard-settings-grid">
//               <div className="setting-item">
//                 <label>Default View</label>
//                 {isEditingSettings ? (
//                   <select
//                     name="defaultView"
//                     value={settingsForm.dashboardPreferences?.defaultView || 'overview'}
//                     onChange={handleDashboardSettingsChange}
//                     className="edit-select"
//                   >
//                     <option value="overview">Overview</option>
//                     <option value="analytics">Analytics</option>
//                     <option value="reports">Reports</option>
//                     <option value="management">Management</option>
//                   </select>
//                 ) : (
//                   <span>
//                     {settingsForm.dashboardPreferences?.defaultView === 'overview' ? 'Overview' :
//                      settingsForm.dashboardPreferences?.defaultView === 'analytics' ? 'Analytics' :
//                      settingsForm.dashboardPreferences?.defaultView === 'reports' ? 'Reports' :
//                      settingsForm.dashboardPreferences?.defaultView === 'management' ? 'Management' : 'Overview'}
//                   </span>
//                 )}
//               </div>

//               <div className="setting-item">
//                 <label>Refresh Interval</label>
//                 {isEditingSettings ? (
//                   <select
//                     name="refreshInterval"
//                     value={settingsForm.dashboardPreferences?.refreshInterval || 300000}
//                     onChange={handleDashboardSettingsChange}
//                     className="edit-select"
//                   >
//                     <option value={60000}>1 minute</option>
//                     <option value={300000}>5 minutes</option>
//                     <option value={600000}>10 minutes</option>
//                     <option value={900000}>15 minutes</option>
//                     <option value={1800000}>30 minutes</option>
//                   </select>
//                 ) : (
//                   <span>
//                     {(settingsForm.dashboardPreferences?.refreshInterval || 300000) / 60000} minutes
//                   </span>
//                 )}
//               </div>

//               <div className="preference-item full-width">
//                 <label className="checkbox-label">
//                   <input
//                     type="checkbox"
//                     name="showCharts"
//                     checked={settingsForm.dashboardPreferences?.showCharts !== false}
//                     onChange={handleDashboardSettingsChange}
//                     disabled={!isEditingSettings}
//                   />
//                   <span className="checkmark"></span>
//                   Show Charts on Dashboard
//                 </label>
//               </div>
//             </div>
//           </div>


//           <div className="detail-section">
//             <h3>Security</h3>
//             <div className="security-actions">
//               <button 
//                 className="security-btn change-password"
//                 onClick={() => setIsChangingPassword(true)}
//               >
//                 Change Password
//               </button>
//             </div>
//           </div>


//           {profileData.recentActivity && profileData.recentActivity.length > 0 && (
//             <div className="detail-section">
//               <h3>Recent Activity</h3>
//               <div className="activity-list">
//                 {profileData.recentActivity.map((activity, index) => (
//                   <div key={index} className="activity-item">
//                     <div className="activity-info">
//                       <span className="activity-type">Login</span>
//                       <span className="activity-ip">IP: {activity.ip}</span>
//                     </div>
//                     <span className="activity-time">
//                       {formatDate(activity.timestamp)} at {formatTime(activity.timestamp)}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>


//       {isChangingPassword && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h3>Change Password</h3>
//               <button 
//                 className="modal-close"
//                 onClick={handleCancelPasswordChange}
//               >
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="password-form">
//                 <div className="form-group">
//                   <label>Current Password</label>
//                   <input
//                     type="password"
//                     name="currentPassword"
//                     value={passwordForm.currentPassword}
//                     onChange={handlePasswordChange}
//                     className="form-input"
//                     placeholder="Enter current password"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>New Password</label>
//                   <input
//                     type="password"
//                     name="newPassword"
//                     value={passwordForm.newPassword}
//                     onChange={handlePasswordChange}
//                     className="form-input"
//                     placeholder="Enter new password"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Confirm New Password</label>
//                   <input
//                     type="password"
//                     name="confirmPassword"
//                     value={passwordForm.confirmPassword}
//                     onChange={handlePasswordChange}
//                     className="form-input"
//                     placeholder="Confirm new password"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button 
//                 className="cancel-btn"
//                 onClick={handleCancelPasswordChange}
//               >
//                 Cancel
//               </button>
//               <button 
//                 className="save-btn"
//                 onClick={handleChangePassword}
//               >
//                 Change Password
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ProfileManagement;

import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/CustomerReport.css';       // customer-only additions (load LAST)
import '../../Styles/ProfileManagement.css';
import {
  getAdminProfile,
  updateAdminProfile,
  changeAdminPassword,
  updateAdminSettings
} from '../../Services/Operations/ProductAPI';
import { Icon, BusSvg, StatCard, Field, Avatar } from './PrimaryUI';

// ---------- helpers ----------
const pad = (n) => String(n).padStart(2, '0');
const formatDate = (d) => {
  if (!d) return 'Never';
  const x = new Date(d);
  if (isNaN(x.getTime())) return 'Never';
  return x.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};
const formatTime = (d) => {
  if (!d) return '';
  const x = new Date(d);
  if (isNaN(x.getTime())) return '';
  return x.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
};
const safeStr = (v) => (v === null || v === undefined ? '' : String(v));
const imgUrl = (p) => (p ? `${process.env.REACT_APP_BASE_URL || 'http://192.168.29.29:5000'}${p}` : '');

const LANGUAGE_LABELS = { en: 'English', hi: 'Hindi', es: 'Spanish', fr: 'French', de: 'German' };
const THEME_LABELS = { light: 'Light', dark: 'Dark', system: 'System' };
const VIEW_LABELS = { overview: 'Overview', analytics: 'Analytics', reports: 'Reports', management: 'Management' };

// ============================================================
// MAIN
// ============================================================
const ProfileManagement = () => {
  const { token } = useSelector(state => state.user);

  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [isEditingSettings, setIsEditingSettings] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '', newPassword: '', confirmPassword: ''
  });
  const [settingsForm, setSettingsForm] = useState({});
  const [profileImage, setProfileImage] = useState(null);
  const [savingProfile, setSavingProfile] = useState(false);
  const [savingSettings, setSavingSettings] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);
  const fileInputRef = useRef(null);

  // ---------- fetch ----------
  const fetchProfileData = async () => {
    try {
      setLoading(true);
      const response = await getAdminProfile(token);
      if (response.success) {
        setProfileData(response.data);
        setEditForm({
          name: response.data.name,
          phone: response.data.phone,
          department: response.data.department
        });
        setSettingsForm(response.data.settings || {});
      } else {
        toast.error('Failed to load profile');
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
      toast.error('Error fetching profile data: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
      setFirstLoad(false);
    }
  };

  useEffect(() => { fetchProfileData(); }, []); // eslint-disable-line

  // ---------- form handlers ----------
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditForm(prev => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSettingsChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettingsForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleDashboardSettingsChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettingsForm(prev => ({
      ...prev,
      dashboardPreferences: {
        ...(prev.dashboardPreferences || {}),
        [name]: type === 'checkbox' ? checked : value
      }
    }));
  };

  // ---------- image upload ----------
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      toast.error('Please select an image file');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Image size should be less than 5MB');
      return;
    }

    const formData = new FormData();
    formData.append('profilePicture', file);
    if (editForm.name) formData.append('name', editForm.name);
    if (editForm.phone) formData.append('phone', editForm.phone);
    if (editForm.department) formData.append('department', editForm.department);

    try {
      const response = await updateAdminProfile(formData, token);
      if (response.success) {
        setProfileData(prev => ({ ...prev, ...response.data }));
        setProfileImage(URL.createObjectURL(file));
        toast.success('Profile picture updated successfully');
      }
    } catch (error) {
      console.error('Error updating profile picture:', error);
      toast.error('Error updating profile picture: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleEditImage = () => fileInputRef.current?.click();

  // ---------- save profile / settings / password ----------
  const handleSaveProfile = async () => {
    try {
      setSavingProfile(true);
      const response = await updateAdminProfile(editForm, token);
      if (response.success) {
        setProfileData(prev => ({ ...prev, ...response.data }));
        setIsEditing(false);
        toast.success('Profile updated successfully');
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error('Error updating profile: ' + (error.response?.data?.message || error.message));
    } finally {
      setSavingProfile(false);
    }
  };

  const handleSaveSettings = async () => {
    try {
      setSavingSettings(true);
      const response = await updateAdminSettings(settingsForm, token);
      if (response.success) {
        setProfileData(prev => ({ ...prev, settings: response.data.settings }));
        setIsEditingSettings(false);
        toast.success('Settings updated successfully');
      }
    } catch (error) {
      console.error('Error updating settings:', error);
      toast.error('Error updating settings: ' + (error.response?.data?.message || error.message));
    } finally {
      setSavingSettings(false);
    }
  };

  const handleChangePassword = async () => {
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      toast.error('New passwords do not match');
      return;
    }
    try {
      setChangingPassword(true);
      const response = await changeAdminPassword(passwordForm, token);
      if (response.success) {
        setPasswordForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
        setIsChangingPassword(false);
        toast.success('Password changed successfully');
      }
    } catch (error) {
      console.error('Error changing password:', error);
      toast.error('Error changing password: ' + (error.response?.data?.message || error.message));
    } finally {
      setChangingPassword(false);
    }
  };

  // ---------- cancel handlers ----------
  const handleCancelEdit = () => {
    setEditForm({
      name: profileData.name,
      phone: profileData.phone,
      department: profileData.department
    });
    setIsEditing(false);
  };

  const handleCancelPasswordChange = () => {
    setPasswordForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    setIsChangingPassword(false);
  };

  const handleCancelSettingsEdit = () => {
    setSettingsForm(profileData.settings || {});
    setIsEditingSettings(false);
  };

  // ============================================================
  if (firstLoad && loading) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="user" size={13} /> Account</span>
          <h1>Profile</h1><p>Loading profile…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">
          {[0, 1, 2].map(i => (
            <div className="prm-skel" key={i}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!profileData) {
    return (
      <div className="prm-page">
        <div className="prm-empty">
          <div className="icon"><Icon name="user" size={44} /></div>
          <h3>Error loading profile</h3>
          <p>We couldn't load your profile data.</p>
          <button className="prm-btn primary" onClick={fetchProfileData}>Retry</button>
        </div>
      </div>
    );
  }

  const stats = profileData.stats || {};

  // ============================================================
  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true">
          <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
        </div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="user" size={13} /> Account</span>
          <h1>Profile Management</h1>
          <p>Manage your account settings, preferences, and security.</p>
        </div>
        <div className="prm-hero-actions">
          {!isEditing ? (
            <button className="prm-add-btn" onClick={() => setIsEditing(true)}>
              <span className="plus"><Icon name="edit" size={14} /></span> Edit Profile
            </button>
          ) : (
            <>
              <button className="pbo-icon-btn" onClick={handleCancelEdit} title="Cancel">
                <Icon name="x" size={17} />
              </button>
              <button className="prm-add-btn" onClick={handleSaveProfile} disabled={savingProfile}>
                <span className="plus"><Icon name="check" size={14} /></span>
                {savingProfile ? 'Saving…' : 'Save Changes'}
              </button>
            </>
          )}
        </div>
      </div>

      {/* STATS */}
      <div className="prm-stats">
        <StatCard icon="check" tone="indigo" label="Total Logins" value={stats.totalLogins || 0} hint="Lifetime logins" delay={80} />
        <StatCard icon="refresh" tone="green" label="Login Streak" value={stats.loginStreak || 0} hint="Consecutive days" delay={160} />
        <StatCard icon="calendar" tone="amber" label="Member Since" value={new Date(profileData.createdAt || Date.now()).getFullYear()} hint={formatDate(profileData.createdAt)} delay={240} />
        <StatCard icon="clock" tone="cyan" label="Last Login" value={new Date(profileData.lastLogin || Date.now()).getDate()} hint={formatDate(profileData.lastLogin) + ' · ' + formatTime(profileData.lastLogin)} delay={320} />
      </div>

      {/* PROFILE CARD */}
      <div className="prm-card cr-card" style={{ marginBottom: 16 }}>
        <div className="prm-card-top">
          <div className="pbo-owner-id">
            <div style={{ position: 'relative' }}>
              <Avatar name={profileData.name} src={profileImage || imgUrl(profileData.profilePicture)} size={72} />
              <button
                className="prm-form-badge"
                style={{
                  position: 'absolute', right: -4, bottom: -4,
                  width: 28, height: 28, cursor: 'pointer', border: '2px solid #fff'
                }}
                onClick={handleEditImage}
                title="Change photo"
              >
                <Icon name="edit" size={14} />
              </button>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleImageUpload}
                accept="image/*"
                style={{ display: 'none' }}
              />
            </div>
            <div>
              <div className="prm-card-no">{safeStr(profileData.role) || 'Administrator'}</div>
              <h3 className="prm-card-title">{safeStr(profileData.name) || 'N/A'}</h3>
              <div className="prm-card-sub">
                <Icon name="mail" size={14} /> {safeStr(profileData.email) || 'N/A'}
              </div>
              <div className="prm-card-sub">
                <Icon name="users" size={14} /> {safeStr(profileData.department) || 'N/A'}
              </div>
            </div>
          </div>
          <span className={`prm-status ${profileData.isActive === false ? 'inactive' : 'active'}`}>
            {profileData.isActive === false ? 'Inactive' : 'Active'}
          </span>
        </div>
      </div>

      {/* PERSONAL INFO */}
      <div className="prm-section-title">Personal Information</div>
      <div className="prm-card cr-card" style={{ marginBottom: 16 }}>
        <div className="prm-fgrid" style={{ padding: 4 }}>
          <Field label="Full Name">
            {isEditing ? (
              <input className="prm-input" name="name" value={editForm.name || ''} onChange={handleInputChange} />
            ) : (
              <div className="prm-input" style={{ display: 'flex', alignItems: 'center' }}>{safeStr(profileData.name)}</div>
            )}
          </Field>
          <Field label="Email Address" note="Email cannot be changed">
            <div className="prm-input" style={{ display: 'flex', alignItems: 'center', color: '#718096' }}>{safeStr(profileData.email)}</div>
          </Field>
          <Field label="Phone Number">
            {isEditing ? (
              <input className="prm-input" type="tel" name="phone" value={editForm.phone || ''} onChange={handleInputChange} placeholder="Enter phone number" />
            ) : (
              <div className="prm-input" style={{ display: 'flex', alignItems: 'center' }}>{safeStr(profileData.phone) || 'Not set'}</div>
            )}
          </Field>
          <Field label="Department">
            {isEditing ? (
              <input className="prm-input" name="department" value={editForm.department || ''} onChange={handleInputChange} />
            ) : (
              <div className="prm-input" style={{ display: 'flex', alignItems: 'center' }}>{safeStr(profileData.department) || 'N/A'}</div>
            )}
          </Field>
          <Field label="Join Date">
            <div className="prm-input" style={{ display: 'flex', alignItems: 'center', color: '#718096' }}>{formatDate(profileData.createdAt)}</div>
          </Field>
          <Field label="Last Updated">
            <div className="prm-input" style={{ display: 'flex', alignItems: 'center', color: '#718096' }}>{formatDate(profileData.updatedAt)}</div>
          </Field>
        </div>
      </div>

      {/* SETTINGS + NOTIFICATIONS + DASHBOARD */}
      <div className="prm-section-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Account Settings</span>
        {!isEditingSettings ? (
          <button className="prm-btn ghost sm" onClick={() => setIsEditingSettings(true)}>
            <Icon name="edit" size={13} /> Edit Settings
          </button>
        ) : (
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="prm-btn ghost sm" onClick={handleCancelSettingsEdit} disabled={savingSettings}>Cancel</button>
            <button className="prm-btn primary sm" onClick={handleSaveSettings} disabled={savingSettings}>
              <Icon name="check" size={13} /> {savingSettings ? 'Saving…' : 'Save'}
            </button>
          </div>
        )}
      </div>
      <div className="prm-card cr-card" style={{ marginBottom: 16 }}>
        <div className="prm-fgrid" style={{ padding: 4 }}>
          <Field label="Language">
            {isEditingSettings ? (
              <select className="prm-input prm-select" name="language" value={settingsForm.language || 'en'} onChange={handleSettingsChange}>
                <option value="en">English</option>
                <option value="hi">Hindi</option>
                <option value="es">Spanish</option>
                <option value="fr">French</option>
                <option value="de">German</option>
              </select>
            ) : (
              <div className="prm-input" style={{ display: 'flex', alignItems: 'center' }}>{LANGUAGE_LABELS[settingsForm.language] || 'English'}</div>
            )}
          </Field>
          <Field label="Timezone">
            {isEditingSettings ? (
              <select className="prm-input prm-select" name="timezone" value={settingsForm.timezone || 'UTC'} onChange={handleSettingsChange}>
                <option value="UTC">UTC</option>
                <option value="Asia/Kolkata">India (IST)</option>
                <option value="America/New_York">New York (EST)</option>
                <option value="Europe/London">London (GMT)</option>
                <option value="Asia/Tokyo">Tokyo (JST)</option>
              </select>
            ) : (
              <div className="prm-input" style={{ display: 'flex', alignItems: 'center' }}>{settingsForm.timezone || 'UTC'}</div>
            )}
          </Field>
          <Field label="Theme">
            {isEditingSettings ? (
              <select className="prm-input prm-select" name="theme" value={settingsForm.theme || 'light'} onChange={handleSettingsChange}>
                <option value="light">Light</option>
                <option value="dark">Dark</option>
                <option value="system">System</option>
              </select>
            ) : (
              <div className="prm-input" style={{ display: 'flex', alignItems: 'center' }}>{THEME_LABELS[settingsForm.theme] || 'Light'}</div>
            )}
          </Field>
        </div>
      </div>

      <div className="prm-section-title">Notification Preferences</div>
      <div className="prm-card cr-card" style={{ marginBottom: 16 }}>
        <div className="prm-chips" style={{ flexWrap: 'wrap', padding: 4 }}>
          <button
            type="button"
            className={`prm-chip ${settingsForm.notifications !== false ? 'active' : ''}`}
            onClick={() => isEditingSettings && setSettingsForm(p => ({ ...p, notifications: p.notifications === false }))}
            disabled={!isEditingSettings}
          >
            {settingsForm.notifications !== false && <Icon name="check" size={12} />} Push Notifications
          </button>
          <button
            type="button"
            className={`prm-chip ${settingsForm.emailNotifications !== false ? 'active' : ''}`}
            onClick={() => isEditingSettings && setSettingsForm(p => ({ ...p, emailNotifications: p.emailNotifications === false }))}
            disabled={!isEditingSettings}
          >
            {settingsForm.emailNotifications !== false && <Icon name="check" size={12} />} Email Notifications
          </button>
          <button
            type="button"
            className={`prm-chip ${settingsForm.smsNotifications ? 'active' : ''}`}
            onClick={() => isEditingSettings && setSettingsForm(p => ({ ...p, smsNotifications: !p.smsNotifications }))}
            disabled={!isEditingSettings}
          >
            {settingsForm.smsNotifications && <Icon name="check" size={12} />} SMS Notifications
          </button>
        </div>
      </div>

      <div className="prm-section-title">Dashboard Preferences</div>
      <div className="prm-card cr-card" style={{ marginBottom: 16 }}>
        <div className="prm-fgrid" style={{ padding: 4 }}>
          <Field label="Default View">
            {isEditingSettings ? (
              <select
                className="prm-input prm-select"
                name="defaultView"
                value={settingsForm.dashboardPreferences?.defaultView || 'overview'}
                onChange={handleDashboardSettingsChange}
              >
                <option value="overview">Overview</option>
                <option value="analytics">Analytics</option>
                <option value="reports">Reports</option>
                <option value="management">Management</option>
              </select>
            ) : (
              <div className="prm-input" style={{ display: 'flex', alignItems: 'center' }}>
                {VIEW_LABELS[settingsForm.dashboardPreferences?.defaultView] || 'Overview'}
              </div>
            )}
          </Field>
          <Field label="Refresh Interval">
            {isEditingSettings ? (
              <select
                className="prm-input prm-select"
                name="refreshInterval"
                value={settingsForm.dashboardPreferences?.refreshInterval || 300000}
                onChange={handleDashboardSettingsChange}
              >
                <option value={60000}>1 minute</option>
                <option value={300000}>5 minutes</option>
                <option value={600000}>10 minutes</option>
                <option value={900000}>15 minutes</option>
                <option value={1800000}>30 minutes</option>
              </select>
            ) : (
              <div className="prm-input" style={{ display: 'flex', alignItems: 'center' }}>
                {(settingsForm.dashboardPreferences?.refreshInterval || 300000) / 60000} minutes
              </div>
            )}
          </Field>
          <Field label="Charts" full>
            <button
              type="button"
              className={`prm-chip ${settingsForm.dashboardPreferences?.showCharts !== false ? 'active' : ''}`}
              onClick={() => isEditingSettings && setSettingsForm(p => ({
                ...p,
                dashboardPreferences: {
                  ...(p.dashboardPreferences || {}),
                  showCharts: p.dashboardPreferences?.showCharts === false
                }
              }))}
              disabled={!isEditingSettings}
            >
              {settingsForm.dashboardPreferences?.showCharts !== false && <Icon name="check" size={12} />}
              Show Charts on Dashboard
            </button>
          </Field>
        </div>
      </div>

      {/* SECURITY */}
      <div className="prm-section-title">Security</div>
      <div className="prm-card cr-card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, padding: 4 }}>
          <div style={{ color: '#4a5568' }}>
            <div style={{ fontWeight: 600 }}>Password</div>
            <div style={{ fontSize: 13, color: '#718096' }}>Last updated: {formatDate(profileData.updatedAt)}</div>
          </div>
          <button className="prm-btn primary" onClick={() => setIsChangingPassword(true)}>
            <Icon name="info" size={15} /> Change Password
          </button>
        </div>
      </div>

      {/* RECENT ACTIVITY */}
      {profileData.recentActivity && profileData.recentActivity.length > 0 && (
        <>
          <div className="prm-section-title">Recent Activity</div>
          <div className="prm-table-wrap" style={{ marginBottom: 16 }}>
            <table className="prm-table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>IP Address</th>
                  <th>Date & Time</th>
                </tr>
              </thead>
              <tbody>
                {profileData.recentActivity.map((activity, index) => (
                  <tr key={index} style={{ animationDelay: `${index * 50}ms` }}>
                    <td><span className="prm-status active">Login</span></td>
                    <td style={{ fontFamily: 'monospace' }}>{safeStr(activity.ip) || '-'}</td>
                    <td>{formatDate(activity.timestamp)} · {formatTime(activity.timestamp)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* CHANGE PASSWORD MODAL */}
      {isChangingPassword && (
        <div className="prm-overlay" onClick={handleCancelPasswordChange}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="info" size={22} /></span>
                <div>
                  <h3>Change password</h3>
                  <p>Keep your account secure</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={handleCancelPasswordChange}>×</button>
            </div>

            <div className="prm-form-body">
              <div className="prm-fgrid">
                <Field label="Current Password" required full>
                  <input
                    className="prm-input"
                    type="password"
                    name="currentPassword"
                    value={passwordForm.currentPassword}
                    onChange={handlePasswordChange}
                    placeholder="Enter current password"
                  />
                </Field>
                <Field label="New Password" required full>
                  <input
                    className="prm-input"
                    type="password"
                    name="newPassword"
                    value={passwordForm.newPassword}
                    onChange={handlePasswordChange}
                    placeholder="Enter new password"
                  />
                </Field>
                <Field label="Confirm New Password" required full>
                  <input
                    className="prm-input"
                    type="password"
                    name="confirmPassword"
                    value={passwordForm.confirmPassword}
                    onChange={handlePasswordChange}
                    placeholder="Confirm new password"
                  />
                </Field>
              </div>
            </div>

            <div className="prm-form-foot">
              <span className="prm-foot-hint">
                {passwordForm.newPassword && passwordForm.newPassword !== passwordForm.confirmPassword
                  ? 'Passwords do not match'
                  : 'Fields marked * are required'}
              </span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={handleCancelPasswordChange} disabled={changingPassword}>Cancel</button>
                <button
                  className="prm-btn primary"
                  onClick={handleChangePassword}
                  disabled={
                    changingPassword ||
                    !passwordForm.currentPassword ||
                    !passwordForm.newPassword ||
                    passwordForm.newPassword !== passwordForm.confirmPassword
                  }
                >
                  <Icon name="check" size={15} /> {changingPassword ? 'Changing…' : 'Change Password'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileManagement;